import { render } from "./PaymentAdditional.vue?vue&type=template&id=51e9d213"
import script from "./PaymentAdditional.vue?vue&type=script&lang=js"
export * from "./PaymentAdditional.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__